/**
 * App 根级是否渲染 @/components/header/index
 * 与各业务页原先内嵌 <hhead /> 的行为保持一致。
 */

/** 不展示公共顶栏的路由 name（登录、静默跳转等） */
const NO_HEADER_ROUTE_NAMES = new Set([
  'login',
  'forgetpwd',
  'pwdLogin',
  'purchasePaySuccess',
  'transfer',
]);

/** 是否在 App.vue 根级展示 hhead */
export function shouldShowAppHeader(route) {
  if (!route) return false;
  if (NO_HEADER_ROUTE_NAMES.has(route.name)) return false;
  // CRM 模块使用独立的 view/crm/header，不走公共 header
  if (String(route.path || '').startsWith('/crm/')) return false;
  return true;
}

/** DefaultNav 占位高度（与 DefaultNav 内 spacer 一致） */
export const DEFAULT_NAV_OFFSET_PX = 54;

/** IndivNav 占位高度（与 IndivNav 内 spacer 一致） */
export const INDIV_NAV_OFFSET_PX = 80;



// WEBPACK FOOTER //
// ./src/utils/appHeader.js